document.addEventListener("DOMContentLoaded", () => {
  const header = document.getElementById("cv-header");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 50) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  });
});